import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { isTokenExpired } from "@/utils/auth";

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/loginPage.vue"),
  },
  {
    path: "/sales",
    name: "sales",
    component: () => import("../views/sales/salesPage.vue"),
  },
  {
    path: "/sales/:id",
    name: "sales-details",
    component: () => import("../views/sales/itemDetails.vue"),
  },
  {
    path: "/stock",
    name: "stock",
    component: () => import("../views/stock/stockPage.vue"),
  },
  {
    path: "/stock/:id",
    name: "stock-details",
    component: () => import("../views/stock/stockDetails.vue"),
  },
  {
    path: "/backOrders",
    name: "backOrders",
    component: () => import("../views/BackOrders/backOrderPage.vue"),
  },
  {
    path: "/backOrders/:id",
    name: "backOrders-details",
    component: () => import("../views/BackOrders/backOrderDatails.vue"),
  },
  {
    path: "/slob",
    name: "slopPage",
    component: () => import("../views/slob/slopPage.vue"),
  },
  {
    path: "/consignment",
    name: "consimentPage",
    component: () => import("@/views/consigment/consimentPage.vue"),
  },
  {
    path: "/ach",
    name: "achievementPage",
    component: () => import("@/views/Achievement/achievementPage.vue"),
  },
  {
    path: "/ach/manager-room",
    name: "managerRoom",
    component: () => import("@/views/Achievement/managerRoom.vue"),
  },
  {
    path: "/invoice/request-quotation",
    name: "RequestQuotation",
    component: () => import("@/views/invoice/RequestQuotation.vue"),
  },
  {
    path: "/invoice/request-invoicing/:id",
    name: "RequestInvoicingDetails",
    component: () => import("@/views/invoice/RequestInvoicingDetails.vue"),
  },
  {
    path: "/fcts",
    name: "fctsPage",
    component: () => import("@/views/FCTS/fctsPage.vue"),
    meta: {
      title: "FCTS",
    },
  },
  {
    path: "/fcts/add",
    name: "addFCST",
    component: () => import("@/views/FCTS/addFCST.vue"),
    meta: {
      title: "Add FCST",
    },
  },
  {
    path: "/inmarket",
    name: "inmarket",
    component: () => import("@/views/inmarket/inmarketPage.vue"),
  },
  {
    path: "/marketing",
    name: "Markting",
    component: () => import("@/views/marketing/marketingPage.vue"),
  },
  {
    path: "/list",
    name: "listPage",
    component: () => import("@/views/list/listPage.vue"),
  },
  {
    path: "/openorders",
    name: "openOrderPage",
    component: () => import("@/views/openOrder/openOrderPage.vue"),
  },
  {
    path: "/purchasing",
    name: "PurchasingPage",
    component: () => import("@/views/purchasing/PurchasingPage.vue"),
  },
  {
    path: "/purchasing/create-order",
    name: "CreatePurchasing",
    component: () => import("@/views/purchasing/createPurchasing.vue"),
  },
  {
    path: "/purchasing/orders-tracking",
    name: "OrdersTracking",
    component: () => import("@/views/purchasing/OrdersTracking.vue"),
  },
  {
    path: "/cook-stock-visibility",
    name: "cookStockVisibility",
    component: () => import("@/views/CookStockVisibility/CookStockPage.vue"),
  },
  {
    path: "/business-overview",
    name: "businessOverViewPage",
    component: () =>
      import("@/views/businessOverView/businessOverViewPage.vue"),
  },
  {
    path: "/cook-stock-visibility/details",
    name: "cookStockDetails",
    component: () => import("@/views/CookStockVisibility/cookStockDetails.vue"),
  },
  {
    path: "/profile",
    name: "profilePage",
    component: () => import("@/views/profilePage.vue"),
  },
  {
    path: "/users-management",
    name: "usersManagement",
    component: () => import("@/views/UsersManagement.vue"),
    meta: { adminOnly: true },
  },
  {
    path: "/roles-management",
    name: "RolesManagement",
    component: () => import("@/views/RolesManagement.vue"),
    meta: { adminOnly: true },
  },
  {
    path: "/edit-roles/:id",
    name: "editRoles",
    component: () => import("@/views/editRoles.vue"),
    meta: { adminOnly: true },
  },
  {
    path: "/create-roles",
    name: "createRoles",
    component: () => import("@/views/createRoles.vue"),
    meta: { adminOnly: true },
  },
  {
    path: "/announcements",
    name: "AnnouncementsList",
    component: () => import("@/views/announcements/AnnouncementsListPage.vue"),
  },
  {
    path: "/announcements/create",
    name: "CreateAnnouncement",
    component: () => import("@/views/announcements/CreateAnnouncement.vue"),
  },
  {
    path: "/announcements/:id",
    name: "EditAnnouncement",
    component: () => import("@/views/announcements/CreateAnnouncement.vue"),
  },
  {
    path: "/stockDynamic/:id",
    name: "stockDynamic",
    component: () => import("@/views/stockDynamic/differencePage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// GLOBAL GUARD
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("user_token");
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const expired = isTokenExpired(token);

  console.log(
    `[Router] Navigating to: ${
      to.path
    }, Token exists: ${!!token}, Expired: ${expired}`,
  );

  if (authRequired) {
    if (!token) {
      console.warn("[Router] No token found, redirecting to login");
      return next("/login");
    }

    if (expired) {
      console.warn("[Router] Token expired, clearing and redirecting to login");
      localStorage.removeItem("user_token");
      return next({ path: "/login", query: { expired: 1 } });
    }

    // Role-based protection
    if (to.meta.adminOnly) {
      const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
      const role = userData?.role?.toLowerCase();
      if (role !== "admin" && role !== "super-admin") {
        console.warn("[Router] Admin only route, redirecting to home");
        return next("/home");
      }
    }
  }

  // Redirect to home if user is already logged in and tries to access login page
  if (to.path === "/login" && token && !expired) {
    console.log("[Router] Already logged in, redirecting to home");
    return next("/home");
  }

  next();
});
export default router;
